import { render, staticRenderFns } from "./CodeShow.vue?vue&type=template&id=3615736f"
import script from "./CodeShow.vue?vue&type=script&lang=js"
export * from "./CodeShow.vue?vue&type=script&lang=js"
import style0 from "./CodeShow.vue?vue&type=style&index=0&id=3615736f&prod&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports